<template>
  <div class="business-page">
    <headerView :seletedindex="seletedindex" />
    <!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'url(' +
          contactUsBanner.imgUrl +
          ')',
      }"
    >
      <!-- <div class="banner-content">
        <h1>{{ contactUsBanner.title }}</h1>
        <p>{{ contactUsBanner.subTitle }}</p>
      </div> -->
    </div>

    <!-- 业务板块 -->
    <div class="business-modules-section">
      <h2 class="business-modules-title">业务板块</h2>
      <p class="business-modules-subtitle">多元化教育体系,全面发展人才培养</p>
      <div
        class="business-modules-grid"
        :class="{
          'three-columns': shouldUseThreeColumns,
          'two-three-layout': useTwoThreeLayout,
        }"
      >
        <el-card
          :class="getCardClasses(index)"
          v-for="(module, index) in businessModules"
          :key="index"
        >
          <div class="business-module-image">
            <img :src="module.image" :alt="module.title" />
          </div>
          <h3 class="business-module-title">{{ module.title }}</h3>
          <p class="business-module-description">{{ module.description }}</p>
          <el-button
            class="learn-more-btn"
            type="primary"
            @click="goToDetail(module.id)"
            >了解更多</el-button
          >
        </el-card>
      </div>
    </div>

    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, businessSegment } from "@/api/index";

export default {
  name: "Business",
  components: {
    headerView,
    footerView,
  },
  data() {
    return {
      seletedindex: 7,
      contactUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      businessModules: [],
    };
  },
  computed: {
    // 判断是否应该使用三列布局（业务板块数超过3个）
    shouldUseThreeColumns() {
      return this.businessModules.length > 3;
    },
    // 是否启用“两列 + 三列”的特殊布局
    useTwoThreeLayout() {
      return this.businessModules.length === 5;
    },
  },
  created() {
    this.$nextTick(() => {
      this.getcontactUsBanner();
      this.getbusinessSegment();
    });
  },
  methods: {
    getCardClasses(index) {
      return {
        'business-module-card': true,
        'last-row-item': this.isLastRowItem(index),
        'first-row-item': this.useTwoThreeLayout && index < 2,
        'second-row-item': this.useTwoThreeLayout && index >= 2,
      };
    },
    async getbusinessSegment() {
      const res = await businessSegment("/api/zaoying/business", {
        pageNumber: 1,
        pageSize: 100,
      });
      console.log(res);
      if (res && res.items.length > 0) {
        this.businessModules = res.items.map((item) => {
          return {
            id: item.id,
            title: item.title,
            description: item.subTitle,
            image: item.imgUrl,
          };
        });
      }
    },
    async getcontactUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 25 });
      if (res && res.length > 0) {
        this.contactUsBanner = res[0];
      }
    },
    // 判断是否为最后一行的元素（当最后一行只有2个元素时）
    // 只有当业务板块数超过3个时，才应用三列布局
    isLastRowItem(index) {
      if (this.useTwoThreeLayout) {
        return false;
      }
      const total = this.businessModules.length;

      // 如果总数不超过3个，不应用特殊布局
      if (total <= 3) {
        return false;
      }

      const itemsPerRow = 3;
      const fullRows = Math.floor(total / itemsPerRow);
      const remainingItems = total % itemsPerRow;

      // 如果最后一行有2个元素，返回true
      if (remainingItems === 2) {
        return index >= fullRows * itemsPerRow;
      }
      return false;
    },
    // 跳转到业务详情页
    goToDetail(index) {
      this.$router.push({
        name: "businessDetail",
        params: { index: index },
      });
    },
  },
};
</script>

<style scoped>
.business-page {
  min-height: 100vh;
  background-color: #fff;
}

.banner {
  background-size: cover;
  background-position: center;
  height: 25vw; /* 设置为视窗宽度的1/3 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px; /* 增大标题字体 */
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px; /* 增大描述文字字体 */
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

/* 业务板块样式 */
.business-modules-section {
  padding: 80px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.business-modules-title {
  font-size: 36px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.business-modules-subtitle {
  font-size: 18px;
  color: #666;
  text-align: center;
  margin-bottom: 60px;
}

.business-modules-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 40px;
}

/* 默认情况下，如果总数不超过3个，元素平分宽度 */
.business-module-card {
  min-width: 0;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
}

/* 当业务板块数超过3个时，使用三列布局 */
.business-modules-grid.three-columns .business-module-card {
  flex: 0 0 calc((100% - 60px) / 3);
  max-width: calc((100% - 60px) / 3);
}

.business-modules-grid.two-three-layout .business-module-card.first-row-item {
  flex: 0 0 calc((100% - 30px) / 2);
  max-width: calc((100% - 30px) / 2);
}

/* 当最后一行只有2个元素时，每个元素占50%宽度 */
.business-modules-grid.three-columns .business-module-card.last-row-item {
  flex: 0 0 calc((100% - 30px) / 2);
  max-width: calc((100% - 30px) / 2);
}

/* 当业务板块数不超过3个时，根据数量调整宽度 */
.business-modules-grid:not(.three-columns) .business-module-card {
  flex: 1 1 calc((100% - 60px) / 3);
  max-width: calc((100% - 60px) / 3);
}

.business-module-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.business-module-image {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: fill;
  margin-bottom: 20px;
}

.business-module-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.business-module-title {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
}

.business-module-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
  text-align: center;
  min-height: 66px;
  padding: 0 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.learn-more-btn {
  width: 120px;
  margin: 0 auto;
  display: block;
  background-color: #409eff;
  border-color: #409eff;
}

.learn-more-btn:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .business-modules-grid.three-columns .business-module-card {
    flex: 0 0 calc((100% - 30px) / 2);
    max-width: calc((100% - 30px) / 2);
  }

  .business-modules-grid.three-columns .business-module-card.last-row-item {
    flex: 0 0 calc((100% - 30px) / 2);
    max-width: calc((100% - 30px) / 2);
  }
}

@media (max-width: 768px) {
  .business-module-card {
    flex: 0 0 100% !important;
    max-width: 100%;
  }

  .business-modules-section {
    padding: 60px 20px;
  }

  .business-modules-title {
    font-size: 28px;
  }
}
</style>

